/**
 * Canonical "which family is this user in?" from a Firestore `users/{uid}` document.
 * Multi-family work introduced `activeFamilyCode`; older data uses `currentFamily` / `familyCode`.
 */
export function primaryFamilyCodeFromUserDoc(userData) {
  if (!userData || typeof userData !== 'object') return null;
  return userData.activeFamilyCode || userData.currentFamily || userData.familyCode || null;
}

/** True if the user document indicates they have completed family onboarding. */
export function userDocHasFamilyContext(userData) {
  return primaryFamilyCodeFromUserDoc(userData) != null;
}
